(function () {
  PreviewController.$inject = ["API_URL", "$http", "$window", "$location"];
  angular.module('calendarApp').controller('PreviewController', PreviewController);

  function PreviewController(API_URL, $http, $window, $location) {
    var preview = this;

    preview.init = function () {
      // All appointments at this stage must be in local storage
      var appointments = localStorage.getItem('reserved-appointments');

      if (!appointments) {
        $location.path('/');
        return;
      }

      appointments = JSON.parse(appointments);
      preview.appointments = appointments;
    };

    preview.init();

    preview.unreserveAppointment = function ($index, appointment) {
      $rootScope.throbber.show();
      $http.put(API_URL + '/api/v1/calendar/appointment/unreserve', {
        appointments: [appointment]
      }).then(function () {
        $rootScope.throbber.hide();
        localStorage.removeItem('reserved-appointments');
        review.appointments.splice($index, 1);

        if (!review.appointments.length) {
          $location.path('/');
        }

        localStorage.setItem('reserved-appointments', JSON.stringify(review.appointments));
      });
    };

    preview.goBack = function () {
      $window.history.back();
    };
  }
})();